import { AxiosInstance } from 'axios';
import { parseActivities, parseActivitiesOrder } from './utils';
import {
  ActivitiesStatusEnum,
  ActivitiesData,
  PromiseActivitiesData,
} from './types';

export const getActivitiesData = (api: AxiosInstance) => ({
  getActivities: async (
    params: any,
    parseData: Function = parseActivities,
  ): Promise<PromiseActivitiesData> => {
    const { data } = await api.get<ActivitiesData>(
      ActivitiesStatusEnum.GET_ACTIVITIES,
      {
        params,
      },
    );
    return { ...data, data: parseData(data.data) };
  },
});

export const getActivitiesOrderData = (api: AxiosInstance) => ({
  getActivitiesOrder: async (
    params: any,
    parseData: Function = parseActivitiesOrder,
  ): Promise<PromiseActivitiesData> => {
    const { data } = await api.get<ActivitiesData>(
      ActivitiesStatusEnum.GET_ACTIVITIES_ORDER,
      {
        params,
      },
    );
    return { ...data, data: parseData(data.data) };
  },
});

const сancelActivityData = (api: AxiosInstance) => ({
  сancelActivity: async (id: string): Promise<any> => {
    const result = await api.post(`activity/order/${id}/cancel`);
    return result;
  },
});

export const activitiesService = (api: AxiosInstance) => {
  if (!api) throw new Error('There is no HTTP client');
  return {
    ...getActivitiesData(api),
    ...getActivitiesOrderData(api),
    ...сancelActivityData(api)
  };
};



// WEBPACK FOOTER //
// ./src/services/api/activities/activitiesService.ts